import { MessageCircle } from "lucide-react";
import { generateContactWhatsAppLink } from "@/utils/whatsapp";
import { cn } from "@/lib/utils";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface FloatingWhatsAppProps {
  message?: string;
  className?: string;
}

export const FloatingWhatsApp = ({ 
  message = "¡Hola! Me gustaría hacer una consulta.",
  className 
}: FloatingWhatsAppProps) => {
  const handleClick = () => {
    const link = generateContactWhatsAppLink(message);
    window.open(link, "_blank");
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            onClick={handleClick}
            className={cn(
              "fixed bottom-6 right-6 z-50",
              "w-14 h-14 rounded-full",
              "bg-[hsl(142,70%,45%)] text-white",
              "flex items-center justify-center",
              "shadow-lg hover:shadow-xl",
              "animate-whatsapp-pulse",
              "hover:scale-110 transition-transform duration-300",
              "focus:outline-none focus:ring-2 focus:ring-[hsl(142,70%,45%)] focus:ring-offset-2",
              className
            )}
            aria-label="Contactar por WhatsApp"
          >
            <MessageCircle className="w-7 h-7" />
          </button>
        </TooltipTrigger>
        <TooltipContent 
          side="left" 
          className="bg-card text-card-foreground border-border shadow-card"
        >
          <p className="font-medium">¿Necesitás ayuda?</p>
          <p className="text-sm text-muted-foreground">Escribinos por WhatsApp</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
